// @flow

import React, { PureComponent } from "react";
import SearchFiltersContainer from "../filters/SearchFiltersContainer";
import ResultsListContainer from "../ResultsListContainer";
import PaginationContainer from "../PaginationContainer";
import apiFetch from "../../utils/_apiFetch";
import { getTranslationCatalog } from "../../utils/_i18n";
import SearchContext from "../searchContext";
import type { SearchContainerState } from "../../utils/_types";
import { getYear, format, endOfYear, startOfYear } from "date-fns";

type CollectionSearchContainerProps = {
  collectionUrl: string,
};

class CollectionSearchContainer extends PureComponent<
  CollectionSearchContainerProps,
  SearchContainerState
> {
  constructor() {
    super();

    this.setFilters = (newFilters) => {
      let { filters } = this.state;

      // always clean batching
      delete filters.b_start;

      Object.keys(newFilters).forEach((key) => {
        const value = newFilters[key];
        if (value || value.length > 0) {
          filters[key] = value;
        } else {
          if (filters.hasOwnProperty(key)) {
            delete filters[key];
          }
        }
      });

      const fetches = [
        apiFetch({
          url: this.props.collectionUrl,
          params: filters,
          method: "GET",
          restApi: true,
        }),
      ];
      Promise.all(fetches).then(([searchResults]) => {
        this.setState({
          ...this.state,
          filters,
          results: searchResults.items,
          batching: searchResults.batching,
        });
      });
    };

    const currentYear = getYear(new Date());
    const yearDate = new Date(currentYear, 0);
    const start = format(startOfYear(yearDate), "yyyy-MM-dd HH:mm:ss");
    const end = format(endOfYear(yearDate), "yyyy-MM-dd HH:mm:ss");

    this.state = {
      results: [],
      portalType: [],
      batching: { numpages: 0, current_page: 0, pagesize: 0 },
      translations: {},
      filters: { fullobjects: true, start, end },
      setFilters: this.setFilters,
    };
  }

  getPortalTypeFromQuery = (data: any): Array<string> => {
    let portalType = [];
    data.query.forEach((criteria) => {
      if (criteria.i === "portal_type") {
        portalType = criteria.v;
      }
    });
    return portalType;
  };

  componentDidMount() {
    //console.log(this.props.collectionUrl);
    const fetches = [
      apiFetch({
        url: this.props.collectionUrl,
        params: this.state.filters,
        method: "GET",
        restApi: true,
      }),
      getTranslationCatalog(),
    ];

    Promise.all(fetches).then((data) => {
      if (data[0]) {
        const searchResults = data[0];

        this.setState({
          ...this.state,
          portalType: this.getPortalTypeFromQuery(searchResults),
          results: searchResults.items,
          batching: searchResults.batching,
          translations: data[1],
        });
      }
    });
  }

  render() {
    return (
      <SearchContext.Provider value={this.state}>
        <div className="collection-search">
          <SearchFiltersContainer />
          <ResultsListContainer />
          <PaginationContainer />
        </div>
      </SearchContext.Provider>
    );
  }
}

export default CollectionSearchContainer;
